/* voltage.js — Voltage accessibility override layer for Align 2.0 (William Dean Chocolates).
   Never edits vendor files: hooks the theme's own events (toggletip-open/close, cart:updated)
   and patches the rendered DOM. Finding numbers refer to williamdeanchocolates-ada-audit-internal.md. */
(function () {
  'use strict';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), summary';

  function visible(el) {
    if (!el) return false;
    if (el.checkVisibility) return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return visible(el) && !el.closest('[inert]') && el.getAttribute('aria-hidden') !== 'true';
    });
  }
  function focusFirst(root) {
    var list = focusables(root);
    if (list.length) { list[0].focus(); return true; }
    return false;
  }
  // voltage: shared Tab loop for overlays the theme does not trap (F2, F3, F5)
  function trap(root) {
    if (root.__voltageTrap) return;
    var handler = function (e) {
      if (e.key !== 'Tab') return;
      var list = focusables(root);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', handler, true);
    root.__voltageTrap = handler;
  }
  function untrap(root) {
    if (!root.__voltageTrap) return;
    document.removeEventListener('keydown', root.__voltageTrap, true);
    root.__voltageTrap = null;
  }
  function hiddenText(text) {
    var s = document.createElement('span');
    s.className = 'visually-hidden';
    s.textContent = text;
    return s;
  }

  /* ---------- Toggletip popovers: mobile nav, mobile search, desktop search (F1, F3, F4, F16) ---------- */
  document.addEventListener('toggletip-open', function (e) {
    var tip = (e.detail && e.detail.toggletip) || e.target;
    if (!tip || !tip.querySelector) return;
    var popover = tip.querySelector('[data-tooltip]');
    if (!popover) return;

    // voltage: F1 — the mobile nav stays aria-hidden="true" while open
    var nav = popover.matches('.nav--mobile') ? popover : popover.querySelector('.nav--mobile');
    if (nav) nav.setAttribute('aria-hidden', 'false');

    // voltage: F4 — the mobile search input is aria-hidden + tabindex=-1 and then focused
    Array.prototype.forEach.call(popover.querySelectorAll('input[type="search"], .search-input'), function (i) {
      i.removeAttribute('aria-hidden');
      i.removeAttribute('tabindex');
    });

    // voltage: F16 — aria-expanded/controls written onto the search <form> is invalid on role=search
    var trig = tip.querySelector('form[data-tooltip-trigger]');
    if (trig) { trig.removeAttribute('aria-expanded'); trig.removeAttribute('aria-controls'); }

    // voltage: F3 — full-screen popovers (mobile nav / mobile search) get an initial focus + Tab loop
    var fullscreen = !!nav || popover.classList.contains('tooltip--mobile') || !!popover.querySelector('.search-input--mobile');
    if (fullscreen) {
      window.setTimeout(function () {
        if (!popover.contains(document.activeElement)) focusFirst(popover);
        trap(popover);
      }, 60);
    }
  });

  document.addEventListener('toggletip-close', function (e) {
    var tip = (e.detail && e.detail.toggletip) || e.target;
    if (!tip || !tip.querySelector) return;
    var popover = tip.querySelector('[data-tooltip]');
    if (popover) {
      var nav = popover.matches('.nav--mobile') ? popover : popover.querySelector('.nav--mobile');
      if (nav) nav.setAttribute('aria-hidden', 'true');
      untrap(popover);
    }
    var trig = tip.querySelector('form[data-tooltip-trigger]');
    if (trig) { trig.removeAttribute('aria-expanded'); trig.removeAttribute('aria-controls'); }
    // voltage: F16 — Esc from the desktop search drops focus to <body>; put it back on the input
    window.setTimeout(function () {
      if (document.activeElement === document.body) {
        var input = tip.querySelector('input[type="search"], .search-input');
        if (input && visible(input)) input.focus();
      }
    }, 30);
  });

  /* ---------- Cart drawer: move focus in, inert the page behind (F2) ---------- */
  function cartDrawer() { return document.querySelector('drawer-component.mini-cart, .mini-cart[role="dialog"]'); }
  function pageChrome() {
    return Array.prototype.filter.call(document.querySelectorAll('#main-content, #nav-wrapper, header, footer, .shopify-section-group-main-footer'), function (el) {
      return el && !el.contains(cartDrawer());
    });
  }
  function onDrawerOpen(drawer) {
    if (drawer.__voltageOpen) return;
    drawer.__voltageOpen = true;
    drawer.__voltageReturn = document.activeElement;
    pageChrome().forEach(function (el) { el.setAttribute('inert', ''); el.__voltageInert = true; });
    window.setTimeout(function () {
      if (drawer.contains(document.activeElement)) return;
      // voltage: focus the close button, not the visually-hidden title — the theme's .visually-hidden:focus rule would reveal it
      var close = drawer.querySelector('.mini-cart__close');
      if (close && visible(close)) close.focus(); else focusFirst(drawer);
    }, 80);
  }
  function releaseInert() {
    pageChrome().forEach(function (el) { if (el.__voltageInert) { el.removeAttribute('inert'); el.__voltageInert = false; } });
  }
  function onDrawerClose(drawer) {
    if (!drawer.__voltageOpen) return;
    drawer.__voltageOpen = false;
    releaseInert();
    var back = drawer.__voltageReturn;
    if (!back || !document.contains(back)) back = document.querySelector('button[name="add"]:not([inert] *), button[name="cart-open"]');
    window.setTimeout(function () {
      if (document.activeElement === document.body && back && document.contains(back) && visible(back)) {
        try { back.focus(); } catch (err) { /* noop */ }
      }
    }, 30);
  }
  function watchDrawer() {
    var drawer = cartDrawer();
    if (!drawer || drawer.__voltageWatched) return;
    drawer.__voltageWatched = true;
    var isOpen = function () { return drawer.classList.contains('open') && !drawer.hasAttribute('hidden'); };
    var sync = function () { if (isOpen()) onDrawerOpen(drawer); else onDrawerClose(drawer); };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['hidden', 'inert', 'class', 'aria-hidden'] });
    // voltage: lift inert BEFORE the theme's own close handler restores focus (it runs synchronously on Esc / close click)
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.__voltageOpen) releaseInert(); }, true);
    document.addEventListener('click', function (e) {
      if (drawer.__voltageOpen && e.target.closest && e.target.closest('.mini-cart__close, .mini-cart__overlay, .drawer__overlay, [data-drawer-close]')) releaseInert();
    }, true);
    sync();
  }

  /* ---------- PDP: lightbox dialog (F5), sticky bar inert (F6), read more (F12), error region (F13), ATC name (F20) ---------- */
  function watchLightbox() {
    var box = document.querySelector('.pdp-lightbox');
    if (!box || box.__voltageWatched) return;
    box.__voltageWatched = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    if (!box.hasAttribute('aria-label')) box.setAttribute('aria-label', 'Image zoom');
    var sync = function () {
      var open = box.classList.contains('pdp-lightbox--open');
      if (open) {
        box.removeAttribute('inert');
        box.__voltageReturn = document.activeElement;
        window.setTimeout(function () {
          var close = box.querySelector('.pdp-lightbox__close');
          if (close) close.focus(); else focusFirst(box);
          trap(box);
        }, 80);
      } else {
        untrap(box);
        box.setAttribute('inert', '');
        var back = box.__voltageReturn;
        if (back && document.contains(back) && (document.activeElement === document.body || box.contains(document.activeElement))) {
          try { back.focus(); } catch (err) { /* noop */ }
        }
      }
    };
    new MutationObserver(sync).observe(box, { attributes: true, attributeFilter: ['class'] });
    if (!box.classList.contains('pdp-lightbox--open')) box.setAttribute('inert', '');
  }
  function watchStickyAtc() {
    Array.prototype.forEach.call(document.querySelectorAll('.sticky-add-to-cart'), function (bar) {
      if (bar.__voltageWatched) return;
      bar.__voltageWatched = true;
      var sync = function () { if (bar.classList.contains('active')) bar.removeAttribute('inert'); else bar.setAttribute('inert', ''); };
      new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
      sync();
    });
  }
  function fixReadMore() {
    Array.prototype.forEach.call(document.querySelectorAll('truncatable-content .ui.expand, truncatable-content .ui.shrink'), function (span) {
      if (span.__voltageDone) return;
      span.__voltageDone = true;
      span.setAttribute('role', 'button');
      span.setAttribute('tabindex', '0');
      span.setAttribute('aria-expanded', span.classList.contains('shrink') ? 'true' : 'false');
      span.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); span.click(); }
      });
      span.addEventListener('click', function () {
        var host = span.closest('truncatable-content');
        if (!host) return;
        window.setTimeout(function () {
          var expanded = span.classList.contains('expand');
          Array.prototype.forEach.call(host.querySelectorAll('.ui.expand, .ui.shrink'), function (s) { s.setAttribute('aria-expanded', expanded ? 'true' : 'false'); });
          var next = host.querySelector(expanded ? '.ui.shrink' : '.ui.expand');
          if (next && visible(next)) next.focus();
        }, 50);
      });
    });
  }
  function fixErrorRegions() {
    Array.prototype.forEach.call(document.querySelectorAll('.main-product__error'), function (el) {
      if (!el.hasAttribute('role')) el.setAttribute('role', 'status');
      if (!el.hasAttribute('aria-live')) el.setAttribute('aria-live', 'polite');
    });
  }
  function fixAtcName() {
    Array.prototype.forEach.call(document.querySelectorAll('button[name="add"][aria-label]'), function (b) {
      if (b.querySelector('.button__text') || b.textContent.trim()) b.removeAttribute('aria-label');
    });
  }

  /* ---------- Names and semantics (F18, F21, F22, F23, F24, F27, F31) ---------- */
  function fixQuantityNames() {
    Array.prototype.forEach.call(document.querySelectorAll('.quantity'), function (q) {
      if (q.__voltageDone) return;
      var scope = q.closest('.cart-item, .sticky-add-to-cart, .main-product, form, .card') || document;
      var titleEl = scope.querySelector('.cart-item__title a, .cart-item__title, h1, .card__title');
      var title = titleEl ? titleEl.textContent.trim().replace(/\s+/g, ' ') : '';
      if (!title) return;
      q.__voltageDone = true;
      var input = q.querySelector('input[name="quantity"]');
      if (input && input.getAttribute('aria-label') && !/[A-Za-z0-9]$/.test(input.getAttribute('aria-label').trim().replace(/for$/, ''))) { /* leave odd labels alone */ }
      if (input) input.setAttribute('aria-label', (input.getAttribute('aria-label') || 'Quantity for').replace(/\s*for\s*$/, ' for') + ' ' + title);
      Array.prototype.forEach.call(q.querySelectorAll('button .visually-hidden'), function (s) {
        if (/for\s*$/.test(s.textContent.trim())) s.textContent = s.textContent.trim() + ' ' + title;
      });
    });
  }
  function fixLocalization() {
    Array.prototype.forEach.call(document.querySelectorAll('ul[role="listbox"] > li:not([role])'), function (li) { li.setAttribute('role', 'none'); });
    Array.prototype.forEach.call(document.querySelectorAll('.localization-form__trigger[aria-label]'), function (btn) {
      if (btn.__voltageDone) return;
      var text = btn.querySelector('.localization-text');
      if (!text) return;
      btn.__voltageDone = true;
      var prefix = hiddenText(btn.getAttribute('aria-label') + ': ');
      btn.insertBefore(prefix, text);
      btn.removeAttribute('aria-label');
    });
  }
  function fixLogo() {
    Array.prototype.forEach.call(document.querySelectorAll('a.logo, .logo a'), function (a) {
      var hasText = !!a.querySelector('.visually-hidden');
      Array.prototype.forEach.call(a.querySelectorAll('img'), function (img) { if (hasText) img.setAttribute('alt', ''); });
    });
    Array.prototype.forEach.call(document.querySelectorAll('img.logo[alt^="Navigate back"]'), function (img) {
      var link = img.closest('a');
      if (link && link.querySelector('.visually-hidden')) img.setAttribute('alt', '');
    });
  }
  function fixStars() {
    Array.prototype.forEach.call(document.querySelectorAll('.rating-product__stars'), function (stars) {
      if (stars.__voltageDone) return;
      var wrapper = stars.closest('[aria-hidden="true"]') || stars;
      var rating = (stars.style.getPropertyValue('--rating') || getComputedStyle(stars).getPropertyValue('--rating') || '').trim();
      if (!rating) return;
      stars.__voltageDone = true;
      wrapper.parentNode.insertBefore(hiddenText('Rated ' + rating + ' out of 5'), wrapper.nextSibling);
    });
  }
  function fixFooterNavs() {
    Array.prototype.forEach.call(document.querySelectorAll('nav.footer__menu:not([aria-label]):not([aria-labelledby])'), function (nav, i) {
      var heading = nav.querySelector('p, h2, h3');
      if (heading && heading.textContent.trim()) {
        if (!heading.id) heading.id = 'voltage-footer-menu-' + i;
        nav.setAttribute('aria-labelledby', heading.id);
      } else nav.setAttribute('aria-label', 'Footer menu ' + (i + 1));
    });
    Array.prototype.forEach.call(document.querySelectorAll('.header__menu'), function (menu) {
      if (menu.closest('nav, [role="navigation"]')) return;
      menu.setAttribute('role', 'navigation');
      if (!menu.hasAttribute('aria-label')) menu.setAttribute('aria-label', 'Main menu');
    });
    Array.prototype.forEach.call(document.querySelectorAll('form[role="search"]:not([aria-label]):not([aria-labelledby])'), function (f, i) {
      f.setAttribute('aria-label', i === 0 ? 'Search' : 'Search ' + (i + 1));
    });
  }
  function fixCardLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('.card--product, .card.card--product'), function (card) {
      if (card.__voltageDone) return;
      card.__voltageDone = true;
      var title = card.querySelector('.card__title a, a.card__title, .card__title');
      var titleLink = title ? (title.tagName === 'A' ? title : title.closest('a') || title.querySelector('a')) : null;
      if (!titleLink) return;
      var href = titleLink.getAttribute('href');
      Array.prototype.forEach.call(card.querySelectorAll('a[href]'), function (a) {
        if (a === titleLink || a.getAttribute('href') !== href) return;
        if (a.classList.contains('card__badge')) return;
        a.setAttribute('tabindex', '-1');
        a.setAttribute('aria-hidden', 'true');
      });
    });
  }
  function fixPickup() {
    Array.prototype.forEach.call(document.querySelectorAll('.pickup-availability'), function (d, i) {
      if (d.getAttribute('role') === 'dialog') return;
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-modal', 'true');
      var t = d.querySelector('.pickup-availability__product-title, h2, h3');
      if (t) { if (!t.id) t.id = 'voltage-pickup-title-' + i; d.setAttribute('aria-labelledby', t.id); }
      else d.setAttribute('aria-label', 'Store availability');
    });
  }
  // voltage: desktop dropdown wrappers carry tabindex="0" + aria-haspopup — a dead tab stop before the real trigger (Enter does nothing there)
  function fixDesktopMenuWrappers() {
    Array.prototype.forEach.call(document.querySelectorAll('.main-nav-item[tabindex="0"]'), function (el) {
      if (el.querySelector('[data-tooltip-trigger]')) { el.removeAttribute('tabindex'); el.removeAttribute('aria-haspopup'); }
    });
  }
  // voltage: F34 filters panel — Escape closes it but focus drops to <body>; return it to the Filters toggle
  function watchFacetsFocus() {
    if (document.__voltageFacetsWatched) return;
    document.__voltageFacetsWatched = true;
    var toggleSel = 'button.toggle-filtering, button[aria-controls="FacetsWrapper"], .grid-archive__filter-triggers button';
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var inFacets = document.activeElement && document.activeElement.closest('#FacetsWrapper, .facets');
      var toggle = document.querySelector(toggleSel);
      if (!inFacets || !toggle) return;
      // Focus the toggle now (the panel is closing) and again after the 300 ms hide transition, which would otherwise blur focus to <body>
      var refocus = function () { if (!document.activeElement || document.activeElement === document.body || (document.activeElement.closest && document.activeElement.closest('#FacetsWrapper, .facets'))) { try { toggle.focus(); } catch (err) { /* noop */ } } };
      window.setTimeout(refocus, 0);
      window.setTimeout(refocus, 400);
    }, true);
  }
  // voltage: F35b desktop predictive search — mark <body> while it is open (CSS hides the theme's dim overlay when the field is
  // empty) and close it through the theme's own API when keyboard focus leaves the search entirely. No open/close on input.
  function watchDesktopSearch() {
    Array.prototype.forEach.call(document.querySelectorAll('toggletip-engine'), function (tip) {
      if (tip.__voltageSearch) return;
      var form = tip.querySelector('form[data-tooltip-trigger]');
      var input = form && form.querySelector('input[type="search"]');
      var pop = tip.querySelector('[data-tooltip]');
      if (!form || !input || !pop || pop.contains(input)) return; // desktop only: the mobile panel contains its own input
      tip.__voltageSearch = true;
      tip.addEventListener('toggletip-open', function () { document.body.setAttribute('data-voltage-search-open', '1'); });
      tip.addEventListener('toggletip-close', function () { document.body.removeAttribute('data-voltage-search-open'); });
      tip.addEventListener('focusout', function (e) {
        if (e.relatedTarget && tip.contains(e.relatedTarget)) return;
        window.setTimeout(function () {
          if (!tip.contains(document.activeElement) && tip.isOpen && typeof tip.close === 'function') tip.close();
        }, 80);
      });
    });
  }
  function fixSearchResults() {
    Array.prototype.forEach.call(document.querySelectorAll('.predictive-search__results-container'), function (c) {
      if (!c.hasAttribute('aria-live')) c.setAttribute('aria-live', 'polite');
    });
  }

  /* ---------- run ---------- */
  function run() {
    watchDrawer();
    watchLightbox();
    watchStickyAtc();
    fixReadMore();
    fixErrorRegions();
    fixAtcName();
    fixQuantityNames();
    fixLocalization();
    fixLogo();
    fixStars();
    fixFooterNavs();
    fixCardLinks();
    fixPickup();
    fixSearchResults();
    fixDesktopMenuWrappers();
    watchFacetsFocus();
    watchDesktopSearch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('cart:updated', function () { window.setTimeout(run, 50); });
  document.addEventListener('shopify:section:load', function () { window.setTimeout(run, 50); });
  document.addEventListener('theme:runtime-ready', function () { window.setTimeout(run, 50); });
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = window.setTimeout(function () { pending = null; run(); }, 250);
  }).observe(document.body, { childList: true, subtree: true });
})();
